// Stesse regole del backend (backend/src/competenze/durata.js)
export function parseDurata(valore) {
  const s = String(valore ?? '').trim();
  if (!s) return { minuti: null };
  let m = s.match(/^(\d{1,3})[:.,](\d{1,2})$/);
  if (m) {
    if (m[2].length !== 2 || Number(m[2]) > 59) return { errore: 'Durata non valida: i minuti vanno da 00 a 59 (es. 1:30)' };
    return { minuti: Number(m[1]) * 60 + Number(m[2]) };
  }
  m = s.match(/^(\d{1,4})\s*(?:'|m|min)$/i);
  if (m) return { minuti: Number(m[1]) };
  m = s.match(/^(\d{1,3})$/);
  if (m) return { minuti: Number(m[1]) * 60 };
  return { errore: 'Durata non valida: usa ore e minuti, es. 1:30' };
}

export function formattaDurata(minuti) {
  if (minuti === null || minuti === undefined) return '';
  return `${Math.floor(minuti / 60)}:${String(minuti % 60).padStart(2, '0')}`;
}

// Testo finale come lo compone il backend (anteprima nel modulo)
export function componiDescrizione(testo, variabili = {}, libera = '') {
  let base = '';
  if (testo) {
    base = testo.replace(/\{(\w+)\}/g, (_, n) => String(variabili?.[n] ?? '').trim());
    base = base.replace(/\s{2,}/g, ' ').replace(/\s+([,.;])/g, '$1').trim();
  }
  const extra = String(libera || '').trim();
  if (base && extra) return `${base} - ${extra}`;
  return base || extra;
}
